import React, {Component} from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Table, {
    TableRow,
    TableCell
} from "@amzn/meridian/table";
import Loader from "@amzn/meridian/loader";
import Link from "@amzn/meridian/link";
import {getPackageHistoryForAssociate} from "../../../commons/api/GetPackageHistoryForAssociateResults.js";
import Text from "@amzn/meridian/text"
import Button from "@amzn/meridian/button";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import chevronRightLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-right-large";
import Icon from "@amzn/meridian/icon";
import Toaster from "@amzn/meridian/toaster"
import Alert from "@amzn/meridian/alert"
import {oldTimeZoneMapper, handleBlankValue} from "../../../commons/CommonUtils.js";
import {FormattedMessage, injectIntl} from "react-intl";
class AssociatePackageHistory extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: true,
            previousPageTokens: [null],
            nextPageToken: null,
            loadSafetyReportView: false,
            toasters: []
        }
        this.setUpdated = props.setUpdated.bind(this)
    }

    getPageSize() {
        return 100;
    }

    async nextButtonClick() {
        this.setState({
            isLoading: true,
            toasters: []
        });

        if (this.state.packageHistory.length < this.getPageSize()) {
            this.setState({
                isLoading: false,
                toasters: [{id: this.props.intl.formatMessage({id: 'search.no_next_entry'}), timeout: 3000}]
            });
        } else {

            let packageHistoryData = await getPackageHistoryForAssociate(this.props.associateLoginId,
                this.getPageSize(), this.state.nextPageToken, this.props.startDate, this.props.endDate);
            this.setUpdated({})
            if (packageHistoryData.packageRecordList.length > 0) {
                this.setState({
                    isLoading: false,
                    previousPageTokens: this.state.previousPageTokens.concat([this.state.nextPageToken]),
                    packageHistory: packageHistoryData.packageRecordList,
                    nextPageToken: packageHistoryData.nextPageToken
                });

            } else {
                this.setState({
                    isLoading: false,
                    toasters: [{id: this.props.intl.formatMessage({id: 'search.no_next_entry'}), timeout: 3000}]
                });
            }
        }
    }

    async previousButtonClick() {
        this.setState({
            isLoading: true,
            toasters: []
        });

        let newPreviousPageTokens = this.state.previousPageTokens.slice(0, -1);
        let prevPageToken = newPreviousPageTokens.slice(-1).pop();

        let packageHistoryData = await getPackageHistoryForAssociate(this.props.associateLoginId, this.getPageSize(), prevPageToken, this.props.startDate, this.props.endDate);
        this.setUpdated({})
        if (packageHistoryData.packageRecordList.length > 0) {
            this.setState({
                isLoading: false,
                previousPageTokens: newPreviousPageTokens,
                packageHistory: packageHistoryData.packageRecordList,
                nextPageToken: packageHistoryData.nextPageToken
            });

        } else {
            this.setState({
                isLoading: false,
                toasters: [{id: this.props.intl.formatMessage({id: 'search.no_previous_entry'}), timeout: 3000}]
            });
        }
    }

    async componentDidMount() {
        let packageHistoryData = await getPackageHistoryForAssociate(this.props.associateLoginId, this.getPageSize(), null, this.props.startDate, this.props.endDate);
        this.setUpdated({})
        this.setState({
            isLoading: false,
            packageHistory: packageHistoryData.packageRecordList ? packageHistoryData.packageRecordList : [],
            nextPageToken: packageHistoryData.nextPageToken,
        })
    }

    sentenceCase(str) {
        if ((str === null) || (str === ''))
            return null;
        else
            str = str.toString();
        return str.toLowerCase().replace(/_/g, " ").replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
    }

    render() {
        return this.state.isLoading ? <Row spacingInset="large" widths={["grid-2"]}><Column /><Loader /></Row> : this.renderHistoryTable();
    }

    renderHistoryTable() {
        return (
            < React.Fragment >
                <Toaster toasts={this.state.toasters} onCloseToast={() => {this.setState({toasters: []})}} alignmentHorizontal="center">
                    {(toast) => <Alert toast={true}>{toast.id}</Alert>}
                </Toaster>
                <Column spacingInline="large large none large">
                    <Row widths={["grid-12"]} spacingInset="none">
                        <div style={{"overflowX": "scroll"}}>
                            <Table showDividers={false} spacing="small">
                                <TableRow>
                                    <TableCell width={120}><Text type="h100"><FormattedMessage id="search.associate.packageHistory_date" defaultMessage="Date" /></Text></TableCell>
                                    <TableCell width={120}><Text type="h100"><FormattedMessage id="search.associate.packageHistory_trackingId" defaultMessage="Tracking Id" /></Text></TableCell>
                                    <TableCell width={120}><Text type="h100"><FormattedMessage id="search.associate.packageHistory_packageEventStatus" defaultMessage="Package Event Status" /></Text></TableCell>
                                    <TableCell width={120}><Text type="h100"><FormattedMessage id="search.associate.packageHistory_scanLocation" defaultMessage="Scan Location" /></Text></TableCell>
                                    <TableCell width={120}><Text type="h100"><FormattedMessage id="search.associate.packageHistory_scanContainer" defaultMessage="Scan Container" /></Text></TableCell>
                                </TableRow>
                                {this.state.packageHistory && this.state.packageHistory.map(history => {
                                    let searchPath = "#" + this.props.previousPath + "/";
                                    let eventTime = new Date(history.eventTime).toLocaleString('en-US', history.stationTimeZone ? {timeZone: oldTimeZoneMapper(history.stationTimeZone)} : undefined);
                                    return <TableRow>
                                        <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{eventTime}</div></TableCell>
                                        <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} ><Link href={searchPath.concat(history.trackingId)}>{history.trackingId}</Link></div></TableCell>
                                        <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(this.sentenceCase(history.packageEventState))}</div></TableCell>
                                        <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.scanLocation)}</div></TableCell>
                                        <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.scanContainer)}</div></TableCell>
                                    </TableRow>
                                })}
                            </Table>
                        </div>
                    </Row>
                    <Row widths={["grid-6", "grid-6"]} spacingInset="none">
                        <Button type="link" onClick={this.previousButtonClick.bind(this)} disabled={this.state.previousPageTokens.length <= 1}><Icon tokens={chevronLeftLargeTokens} /></Button>
                        <Button type="link" onClick={this.nextButtonClick.bind(this)}><Icon tokens={chevronRightLargeTokens} /></Button>
                    </Row>
                </Column>
            </React.Fragment>
        )
    }
}




export default injectIntl(AssociatePackageHistory);




// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/AssociatePackageHistory.js